/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Input, Popover, OverlayTrigger, Row, Col} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';


var DistanceWeightsDialog = React.createClass({
    getInitialState() {
        let r = getLinkMinMax(this.props.net);
        let scale = 1.0;
        let offset = 0.0;
        return {
            minDist: r.pmin,
            maxDist: r.pmax,
            strScale: scale.toPrecision(4),
            strOffset: offset.toPrecision(4),
            scaleMinDist: scale * r.pmin + offset,
            scaleMaxDist: scale * r.pmax + offset,
            linkLengthMap: r.linkLengthMap
        }
    },

    componentWillReceiveProps(nextProps) {
        let r = getLinkMinMax(this.props.net);
        let scale = parseFloat(this.state.strScale);
        let offset = parseFloat(this.state.strOffset);
        this.setState(Object.assign({}, this.state, {
            minDist: r.pmin,
            maxDist: r.pmax,
            scaleMinDist: scale * r.pmin + offset,
            scaleMaxDist: scale * r.pmax + offset,
            linkLengthMap: r.linkLengthMap
        }));
    },

    scaleChange(e) {
        let scale = parseFloat(e.target.value);
        let offset = parseFloat(this.state.strOffset);

        this.setState(Object.assign({}, this.state, {
            strScale: e.target.value,
            scaleMinDist: scale * this.state.minDist + offset,
            scaleMaxDist: scale * this.state.maxDist + offset
        }));
    },

    scaleStatus() {
        if (isNaN(parseFloat(this.state.strScale))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    offsetChange(e) {
        let scale = parseFloat(this.state.strScale);
        let offset = parseFloat(e.target.value);
        this.setState(Object.assign({}, this.state, {
            strOffset: e.target.value,
            scaleMinDist: scale * this.state.minDist + offset,
            scaleMaxDist: scale * this.state.maxDist + offset
        }));
    },

    offsetStatus() {
        if (isNaN(parseFloat(this.state.strOffset))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    badTransform() {
        return isNaN(parseFloat(this.state.strScale)) || isNaN(parseFloat(this.state.strOffset));
    },

    helpPopover(){
        return (<Popover id="DistanceWeightsHelpPopover" title="Port Numbering Help">
            <p>This command allows you to assign distance based weights to all links in the network.</p>
        </Popover>)
    },

    applyHandler() {
        if (this.badTransform()) {
            return;
        }
        let links = this.props.net.links;
        let newLinks = []
        let scale = parseFloat(this.state.strScale);
        let offset = parseFloat(this.state.strOffset);
        for (let link of links) {
            let newLink = Object.assign({}, link);
            let linkKey = link.source + "-" + link.target;
            newLink.weight = this.state.linkLengthMap.get(linkKey)*scale + offset;
            newLinks.push(newLink);
        }
        let newNet = Object.assign({}, this.props.net, {links: newLinks});
        this.props.updateWeights(newNet);
    },

    render(){

        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="dist-wt-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>Distance Based Weights</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form-horizontal">
                    <Row>
                        <Col  xsOffset={1}>
                        <p>Link Pixel Distances</p> </Col>
                    </Row>
                    <Row>
                        <Col xs={2} xsOffset={1}><label className="control-label">Min</label></Col>
                        <Col xs={3}><input type="text" value={this.state.minDist.toPrecision(4)}
                                           readOnly className="form-control"/></Col>
                        <Col xs={2}  xsOffset={1}><label className="control-label">Max</label></Col>
                        <Col xs={3}><input type="text" value={this.state.maxDist.toPrecision(4)}
                                           readOnly className="form-control"/></Col>
                    </Row>
                    <Row>
                        <Col  xsOffset={1}><p><em>Scaled</em> Distances</p></Col>
                    </Row>
                    <Row>
                        <Col xs={2} xsOffset={1}><label className="control-label">Min</label></Col>
                        <Col xs={3}><input type="text" value={this.state.scaleMinDist.toPrecision(4)}
                                           readOnly className="form-control"/></Col>
                        <Col xs={2} xsOffset={1}><label className="control-label">Max</label></Col>
                        <Col xs={3}><input type="text" value={this.state.scaleMaxDist.toPrecision(4)}
                                           readOnly className="form-control"/></Col>
                    </Row>
                    <Row>
                        <Col  xsOffset={1}><p><em>Parameters</em></p></Col>
                    </Row>
                    <Row>
                        <div className={this.scaleStatus()}>
                        <Col xs={2} xsOffset={1}><label className="control-label">Scale</label></Col>
                        <Col xs={3}><input type="text" value={this.state.strScale}
                                           onChange={this.scaleChange} className="form-control"/></Col>
                            </div>
                        <div className={this.offsetStatus()}>
                        <Col xs={2} xsOffset={1}><label className="control-label">Offset</label></Col>
                        <Col xs={3}><input type="text" value={this.state.strOffset}
                                           onChange={this.offsetChange} className="form-control"/></Col>
                            </div>
                    </Row>
                    </form>
            </Modal.Body>
            <Modal.Footer>
                 <Button bsStyle="primary"
                            onClick={this.applyHandler} disabled={this.badTransform()}>Apply </Button>
                <Button onClick={this.props.close} >Close</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

function getLinkMinMax(net) {
        let links = net.links;
        let nodes = net.nodes;
        let linkLengthMap = new Map();
        let pmin = Infinity;
        let pmax = 0;
        for (let link of links) {
            let srcNode = nodes.find(n => link.source === n.id);
            let trgNode = nodes.find(n => link.target === n.id);
            let linkKey = link.source + "-" + link.target;
            let euclid = Math.sqrt(Math.pow(srcNode.x - trgNode.x, 2) + Math.pow(srcNode.y - trgNode.y, 2));
            linkLengthMap.set(linkKey, euclid);
            pmin = euclid < pmin ? euclid : pmin;
            pmax = euclid > pmax ? euclid : pmax;
        }
        return {pmin: pmin, pmax: pmax, linkLengthMap: linkLengthMap};
}

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showDistanceWeightsModal,
        net: state.net
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_DIST_WEIGHT_DIALOG'});
        },
        updateWeights: (net) => {
            dispatch({type: 'UPDATE_LINK_WEIGHTS', net: net});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DistanceWeightsDialog)




// WEBPACK FOOTER //
// ./src/netManip/DistanceWeightsDialog.js